'use client';

import type * as React from 'react';

import { Icon, SlotIcon } from '@coop/cds-components';
import { CheckIcon, TriangleAlertIcon } from '@coop/icons';
import classNames from 'classnames';

import type { NotficationThemeType } from './Notification.types';

import { ModalContextHeader } from '../Modal/ModalHeader';
import styles from './Notification.module.scss';

const NotificationContent = ({
    size = 'default',
    ...props
}: {
    show: boolean;
    header?: string;
    message: string | undefined;
    bottomSlot?: React.ReactNode;
    size?: 'default' | 'productCard';
    type: 'alert' | 'success' | 'custom';
    theme?: NotficationThemeType;
    iconSlot?: React.ComponentProps<typeof SlotIcon>['icon'];
    asModal?: boolean;
}) => {
    let colorTheme: NotficationThemeType | undefined = props.theme;
    switch (props.type) {
        case 'alert':
            colorTheme = 'darkPink';
            break;
        case 'success':
            colorTheme = 'darkGreen';
            break;
        case 'custom':
            colorTheme = props.theme;
            break;
        default:
            break;
    }

    const HeaderTag = props.asModal ? ModalContextHeader : 'p';
    const MessageTag = props.asModal && !props.header ? ModalContextHeader : 'p';

    return (
        <div
            className={classNames(
                styles.Content,
                size && styles[`Content-size--${size}`],
                colorTheme && styles[`Content-theme--${colorTheme}`],
            )}
        >
            <div className={styles.Icon} aria-hidden>
                {(() => {
                    switch (props.type) {
                        case 'alert':
                            return <Icon icon={<TriangleAlertIcon />} size="medium" />;
                        case 'success':
                            return <Icon icon={<CheckIcon />} size="medium" />;
                        case 'custom':
                            return (
                                props.iconSlot && <SlotIcon icon={props.iconSlot} size="medium" />
                            );
                        default:
                            return null;
                    }
                })()}
            </div>
            <div className={styles.TextContent}>
                {!!props.header && <HeaderTag className={styles.Header}>{props.header}</HeaderTag>}
                {!!props.message && (
                    <MessageTag className={styles.Message}>{props.message}</MessageTag>
                )}
            </div>
            {props.bottomSlot}
        </div>
    );
};

export default NotificationContent;
